import { endpoints, request } from '!core/api';

export const otpService = {
  getOTP: ({ token }) => request.post(endpoints.chnn(`otp?token=${token}`)),

  getOTPAuth: ({
    ordType,
    symbol,
    orderQty,
    price,
    amount,
    currency,
    currencySymbol,
  }) => {
    const params = ordType
      ? `?ordType=${ordType}&symbol=${symbol}${
          price ? `&orderQty=${orderQty}` : ''
        }${
          price ? `&price=${price}` : ''
        }&amount=${amount}&currency=${currency}&currencySymbol=${currencySymbol}`
      : '';

    return request.post(endpoints.chnn(`otpAuth${params}`));
  },

  getOTPByUser: ({ username }) =>
    request.post(endpoints.chnn(`otpByUser?username=${username}`)),

  getOTPOnboarding: ({
    openingRequestId,
    entityName,
    otpSendType,
    onboardingState,
  }) =>
    request.post(
      endpoints.chnn(
        `wsbOtpOnboardingNoAuth?onboardingId=${openingRequestId}&entityName=${entityName}&otpSendType=${otpSendType}&onboardingState=${onboardingState}`,
      ),
    ),

  validateOTP: ({ token, otp }) =>
    request.post(endpoints.users(`validateotp?token=${token}&otp=${otp}`)),

  validateOTPAuth: ({ otp }) =>
    request.post(endpoints.users(`validateotpAuth?&otp=${otp}`)),

  validateLoginOtp: ({ username, loginId, otp }) =>
    request.postWebService(endpoints.webservices('validateOtp'), {
      username,
      loginId,
      otp,
    }),
};
